<template>
  <el-dialog
    title="提示"
    :visible.sync="dialogVisible"
    width="1100px">
    <div class="personnel">
      <div class="personnel-left">
        <el-tabs type="border-card" size="mini" v-model="where_personnel_type">
          <el-tab-pane :disabled="disabled" label="人事架构" name="hr_tree">
            <HrTree @nodeClick="onHrTree" height="calc(50vh - 40px)" />
          </el-tab-pane>
          <el-tab-pane :disabled="disabled" label="收藏" name="favorite">
            <div class="history_user_body">
              <div v-for="(item,index) in user_favorite_list" :key="index"  class="user_role_body_item" style="display: flex; margin-bottom: 4px;">
                <div style="width: 190px" @click="addUser(item)" class="history_user_body_item" >
                  {{item.name}}  - {{item.department_name}}
                </div>
                <div>
                  <el-button size="mini" type="danger" @click="delFavoriteUser(item)">移除</el-button>
                </div>
              </div>
            </div>
          </el-tab-pane>
          <el-tab-pane :disabled="disabled" label="常用选择" name="history_user">
            <div class="history_user_body" style="height: calc(50vh - 40px);">
              <div v-for="(item,index) in user_history_list" v-if="user_history_list.length" :key="index" @click="addUser(item)" class="history_user_body_item">{{item.name}} - {{item.department_name}} - {{item.position_name}}</div>
            </div>
          </el-tab-pane>
          <el-tab-pane :disabled="disabled" label="角色" name="user_role">
            <div class="user_role_body">
              <div v-for="(item,index) in user_role_list" :key="index" @click="onUserRole(item)" class="user_role_body_item" :class="{active:(item.id===where.role_id)}">{{item.name}}</div>
            </div>
          </el-tab-pane>
        </el-tabs>
      </div>
      <div class="personnel-right">
        <!-- 搜索框 -->
        <div style="margin-bottom: 10px;">
          <el-descriptions :column="2" border size="mini">
            <el-descriptions-item label="姓名">
              <el-row :gutter="2">
                <el-col :span="12">
<!--                  <el-input size="mini" :disabled="disabled" placeholder="" v-model="where.keyword" clearable></el-input>-->
                  <el-autocomplete
                    v-model="where.keyword"
                    :fetch-suggestions="querySearchAsync"
                    placeholder="请输入姓名"
                    @select="handleSelect"
                    style="width: 100%;"
                  ></el-autocomplete>
                </el-col>
                <el-col :span="6">
                  <el-checkbox v-model="isShowDepart">显示离职</el-checkbox>
                </el-col>
                <el-col :span="6">
                  <el-button type="primary" size="mini" @click="getList()">搜索</el-button>
                </el-col>
              </el-row>
            </el-descriptions-item>
          </el-descriptions>
        </div>
        <!-- 表格 -->
        <div>
          <el-table size="mini" v-if="pageData" v-loading="loading" :data="pageData.list">
            <el-table-column prop="username" label="姓名" align="center" width="90"></el-table-column>
            <el-table-column label="部门 " align="center" >
              <template slot-scope="scope">
                <a href="javascript:void(0)" :title="scope.row.ancestor_name">{{scope.row.department_name}}</a>
              </template>
            </el-table-column>
            <el-table-column prop="position_name" label="职位 " align="center" width="140"></el-table-column>
            <el-table-column prop="operation" label="操作">
              <template slot-scope="scope">
                <el-button size="mini" type="primary" @click="addUser(scope.row)">选择</el-button>
                <el-button size="mini" type="warning" @click="favoriteUser(scope.row)">收藏</el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <!-- 分页 -->
        <div class="pagination-wrap">
          <el-pagination background layout="prev, pager, next" :total=pageData.total
                         :page-size="pageData.page_size * 1" :current-page="pageData.page * 1"
                         @current-change="pageChange"></el-pagination>
        </div>
      </div>
      <div class="personnel-right-select">
        <el-descriptions :column="1" border direction="vertical" size="mini">
          <el-descriptions-item label="选择的人员">
            <div class="personnel-right-select-view">
              <el-tag
                v-for="(tag,index) in select_user"
                :key="index"
                closable
                @close="deleteUser(index)" style="margin: 3px">
                {{tag.name}}
              </el-tag>
            </div>
          </el-descriptions-item>
        </el-descriptions>
      </div>
    </div>
    <div class="personnel-footer">
      <el-button size="mini" type="info" @click="closeFun">取 消</el-button>
      <el-button size="mini" type="primary" @click="confirmFun">确 定</el-button>
    </div>
  </el-dialog>

</template>

<script>
import HrTree from "./HrTree";
import Http from "../common/Http";
export default {
  name: "selectPersonnel",
  components: {HrTree},
  data(){
    return {
      where_personnel_type:"hr_tree",
      dialogVisible:false,
      loading:false,
      where:{},
      pageData:{
        list:[],
        page:1,
        total:0,
        page_size:9
      },
      user_role_list:[],
      user_favorite_list:[],
      select_user:[],
      user_history_list:[],
      callback_fun:null,
      disabled:false,
      user_len:null,
      isShowDepart: false
    }
  },
  mounted() {
    // this.getUserRoleList()
  },
  methods:{
    initConfig(){
      this.where_personnel_type='hr_tree';
      this.where={}
      this.pageData={
        list:[],
        page:1,
        total:0,
        page_size:9
      };
      this.user_role_list=[];
      this.user_favorite_list = [];
      this.select_user=[];
      this.user_history_list=[];
      this.user_len=null;
      this.callback_fun=undefined;
      this.disabled=false;
    },
    /**
     * 显示选人
     * @param department_id 部门ID
     * @param role_id 角色ID
     * @param user_ids 已经选择的人ID
     * @param len 可选人数
     * @param type 筛选类型 hr_tree=人事架构、user_role=用户角色
     * @param callback_fun
     */
    show({
           department_id=null,
           role_id=null,
           user_ids=null,
           user_len=null,
           type="",
         },callback_fun){
      const that = this;
      that.initConfig();
      that.select_user=[];
      that.where={};
      department_id&&(that.where.department_id=department_id,that.disabled=true,that.where_personnel_type='hr_tree');
      role_id&&(that.where.role_id=role_id,that.disabled=true,that.where_personnel_type='user_role');
      type&&(that.where_personnel_type=type,that.disabled=true);
      that.user_len=user_len;
      // user_ids&&(that.where.ids=user_ids);
      if(user_ids){
        that.getUserList(user_ids,data=>{
          that.select_user=data||[]
        })
      }
      that.dialogVisible=true;
      if(typeof callback_fun==="function"){
        that.callback_fun=callback_fun;
      }
      that.getList();
      that.getUserRoleList();
      that.getUserHistory();
      that.getFavoriteUserList()
    },
    confirmFun(){
      if(typeof this.callback_fun ==="function"){
        this.callback_fun(this.select_user);
        this.callback_fun=undefined;
      }
      this.dialogVisible=false;
    },
    closeFun(){
      if(typeof this.callback_fun ==="function"){
        this.callback_fun=undefined;
      }
      this.dialogVisible=false;
    },
    onHrTree(data){
      // console.log(data)
      const that = this;
      that.pageData.page=1;
      that.where.department_id=data.id;
      that.getList();
    },
    onUserRole(item){
      const that = this;
      if(!that.disabled){
        that.pageData.page=1;
        that.where.role_id=item.id;
        that.getList();
      }
    },
    getList() {
      const that = this;
      if (this.isShowDepart == true) {
        this.where['status'] = ""
      } else {
        this.where['status'] = 1
      }
      let from_data=JSON.parse(JSON.stringify(this.where))
      from_data.page=that.pageData.page
      from_data.page_size= that.pageData.page_size
      that.loading=true;
      Http.post("hr/user/getUserList",from_data,res=>{
        if (res.code === 0) {
          that.pageData.list = res.data;
          that.pageData.total = res.total;
        }else {
          this.$message.error({
            message: res.msg,
            type: "error",
          });
        }
        that.loading=false;
      })
    },
    getUserList(user_ids,callback){
      const that = this;
      let from_data=JSON.parse(JSON.stringify({ids:user_ids}))
      from_data.page=1
      from_data.page_size= 100
      Http.post("hr/user/getUserList",from_data,res=>{
        if (res.code === 0) {
          typeof callback==="function"&&callback(res.data)
        }
      })
    },
    getUserHistory(){
      const that = this;
      Http.post("flow/FlowProcessSteps/getUserHistory",{},res=>{
        if (res.code) {
          that.user_history_list=res.data
        }
      })
    },
    pageChange(i) {
      this.pageData.page = i;
      this.pageData.page_size = 9;
      this.getList();
    },
    addUser(data){
      const that = this;
      if(that.user_len===null){
        //默认下可以无限选人
        let user=this.select_user.find(ret=>{
          return ret.id===data.id;
        })
        if(!user){
          this.select_user.push(data)
        }
      }else {
        if(that.user_len===1){
          //只有一个人的时候是可以替换
          let user=this.select_user.find(ret=>{
            return ret.id===data.id;
          })
          if(!user){
            if(this.select_user.length>0){
              this.select_user.splice(0,1)
            }
            this.select_user.push(data)
          }
        }else if(this.select_user.length<that.user_len) {
          //其余条件下人数必须小于要求
          let user=this.select_user.find(ret=>{
            return ret.id===data.id;
          })
          if(!user){
            this.select_user.push(data)
          }
        }else {
          that.$message.error(`只可以选择${that.user_len}人`);
        }
      }
    },
    deleteUser(index){
      this.select_user.splice(index,1);
    },
    getUserRoleList() {
      const that = this;
      let where={};
      Http.get("flow/UserRole/getList",{
        where:JSON.stringify(where),
        field:"id,name",
        page: 1,
        page_size: 300
      },res=>{
        if(res.code) {
          that.user_role_list=res.data.list
        }
      })
    },
    querySearchAsync(queryString, cb) {
      const that = this;
      if(!queryString){
        cb([])
        return false
      }
      let from_data=JSON.parse(JSON.stringify(this.where))
      from_data.keyword=queryString;
      from_data.page=1
      from_data.page_size= 50
      Http.post("hr/user/getUserList",from_data,res=>{
        if (res.code === 0) {
          cb(res.data.map(ret=>{return {
            value:ret.name,
          }}));
        }
      })
    },
    handleSelect(item) {
      console.log(item);
    },
    getFavoriteUserList() {
      const that = this;
      Http.get("flow/user/favoriteUserList",{},res=>{
        if(res.code) {
          that.user_favorite_list = res.data
        }
      })
    },
    favoriteUser(item) {
      let that = this
      Http.get("flow/user/addFavoriteUser", {'user_id':item['id']},res=>{
        if (res.code) {
          that.$message.success(`操作成功!`);
          that.getFavoriteUserList()
        } else {
          that.$message.error(`操作失败!`);
        }
      })
    },
    delFavoriteUser(item) {
      let that = this
      Http.get("flow/user/delFavoriteUser", {'user_id':item['id']},res=>{
        if (res.code) {
          that.$message.success(`操作成功!`);
          that.getFavoriteUserList()
        } else {
          that.$message.error(`操作失败!`);
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../common";
.personnel{
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  .personnel-left{
    width: 300px;
    height: 50vh;
    //overflow-y: scroll;

    .user_role_body{
      height: 50vh;
      overflow-y: scroll;
      .user_role_body_item{
        color: #6f7175;
        width: 100%;
        cursor: pointer;
        padding: 2px 0 2px 5px;
        margin: 2px 0;
        &:hover{
          background-color: #e8e8e8;
        }
        &:active{
          background-color: #b2c7d0;
        }
        &.active{
          background-color: #b2c7d0;
        }
      }
    }
    .history_user_body{
      height: 50vh;
      overflow-y: scroll;
      .history_user_body_item{
        color: #6f7175;
        width: 100%;
        cursor: pointer;
        padding: 2px 0 2px 5px;
        margin: 2px 0;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
        &:hover{
          background-color: #e8e8e8;
        }
        &:active{
          background-color: #b2c7d0;
        }
        &.active{
          background-color: #b2c7d0;
        }
      }
    }
  }
  .personnel-right{
    width: 600px;
    margin-left: 5px;
    height: 100%;
  }
  .personnel-right-select{
    width: 150px;
    .personnel-right-select-view{
      height: 50vh;
      overflow-y: scroll;
    }
  }
}
.personnel-footer{
  margin-top: 10px;
  width: 100%;
  text-align: right;
}
</style>



// WEBPACK FOOTER //
// src/components/Admin/Personnel/components/selectPersonnel.vue